import "../styles/external/animate.css/animate.css";

document.addEventListener('DOMContentLoaded', () => {
    const elements = Array.from(document.querySelectorAll('[data-animation]'));
    if (!elements.length) return;

    const isRevealed = (el) => el.dataset.revealed === 'true';
    const markRevealed = (el) => { el.dataset.revealed = 'true'; };

    elements.forEach(el => {
        if (isRevealed(el)) return;
        if (el.dataset.childs === 'true') {
            Array.from(el.children).forEach(child => {
                if (child.classList.contains('wp-block-spacer')) return;
                if (isRevealed(child)) return;
                child.classList.add('animate__hidden');
            });
        } else {
            el.classList.add('animate__hidden');
        }
    });

    const reveal = (el) => {
        if (isRevealed(el)) return;
        const animClass = el.dataset.animation;
        if (!animClass) return;
        if (el.dataset.childs === 'true') {
            let idx = 0;
            Array.from(el.children).forEach(child => {
                if (child.classList.contains('wp-block-spacer')) return;
                if (isRevealed(child)) return;
                const delay = (parseFloat(el.dataset.delay) * 0.1 || 0) + idx * 0.15;
                child.style.animationDelay = `${delay}s`;
                child.classList.remove('animate__hidden');
                child.classList.add('animate__animated', animClass);
                markRevealed(child);
                idx++;
            });
            markRevealed(el);
        } else {
            const delay = parseFloat(el.dataset.delay) * 0.1 || 0;
            el.style.animationDelay = `${delay}s`;
            el.classList.remove('animate__hidden');
            el.classList.add('animate__animated', animClass);
            markRevealed(el);
        }
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                reveal(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0,
        rootMargin: '0px 0px -10% 0px',
    });

    elements.forEach(el => observer.observe(el));
});
